'use strict';

angular.module('kerp-forms.forms')
  .service('KR_CA_MAPPINGS', ['FormFieldMappings', 'addressFormatterService', 'objectUtils',
    function (FormFieldMappings, addressFormatterService, objectUtils) {

      this.mappings = function () {
        return FormFieldMappings
          .buildWithMappings({
            'person.details.title': 'title',
            'person.details.firstName': 'firstName',
            'person.details.lastName': 'lastName',
            'person.details.nationalInsuranceNumber': 'nationalInsuranceNumber',
            'person.details.phoneNumber': 'phoneNumber',
            'person.intro.havePartner': 'careAssessment.hasPartner',
            'person.intro.dob': 'dateOfBirth',
            'person.details.address': 'address.formatted',

            'clientReference': 'careAssessment.clientReference',

            'person.intro.declarePartnerFinances': 'careAssessment.declarePartnerFinances',
            'person.income.benefitsPaidAsCouple': 'careAssessment.benefitsPaidAsCouple',
            'person.intro.isEntitledToCarersPremium': 'careAssessment.isEntitledToCarersPremium',

            'person.income.retirementPension': 'careAssessment.retirementPension.amount',
            'person.income.retirementPensionPeriod': 'careAssessment.retirementPension.frequency',

            'person.income.incapacityBenefit': 'careAssessment.incapacityBenefit.amount',
            'person.income.incapacityBenefitPeriod': 'careAssessment.incapacityBenefit.frequency',

            'person.income.warPension': 'careAssessment.warPension.amount',
            'person.income.warPensionPeriod': 'careAssessment.warPension.frequency',

            'person.income.warSpecialPayment': 'careAssessment.warSpecialPayment.amount',
            'person.income.warSpecialPaymentPeriod': 'careAssessment.warSpecialPayment.frequency',

            'person.income.childBenefit': 'careAssessment.childBenefit.amount',
            'person.income.childBenefitPeriod': 'careAssessment.childBenefit.frequency',

            'person.income.carersAllowance': 'careAssessment.carersAllowance.amount',
            'person.income.carersAllowancePeriod': 'careAssessment.carersAllowance.frequency',

            'person.income.pensionGuaranteeCredit': 'careAssessment.pensionGuaranteeCredit.amount',
            'person.income.pensionGuaranteeCreditPeriod': 'careAssessment.pensionGuaranteeCredit.frequency',

            'person.income.pensionSavingsCredit': 'careAssessment.pensionSavingsCredit.amount',
            'person.income.pensionSavingsCreditPeriod': 'careAssessment.pensionSavingsCredit.frequency',

            'person.income.attendanceAllowance': 'careAssessment.attendanceAllowance',
            'person.income.mobilityAllowance': 'careAssessment.mobilityAllowance',

            'person.income.hasUniversalCredit': 'careAssessment.hasUniversalCredit',
            'person.income.universalCredit.standardAllowance': 'careAssessment.universalCreditAllowances.standardAllowance',
            'person.income.universalCredit.housingElement': 'careAssessment.universalCreditAllowances.housingElement',
            'person.income.universalCredit.children': 'careAssessment.universalCreditAllowances.children',
            'person.income.universalCredit.disabledChild': 'careAssessment.universalCreditAllowances.disabledChild',
            'person.income.universalCredit.childcare': 'careAssessment.universalCreditAllowances.childcare',
            'person.income.universalCredit.carer': 'careAssessment.universalCreditAllowances.carer',
            'person.income.universalCredit.limitedWorkCapability': 'careAssessment.universalCreditAllowances.limitedWorkCapability',
            'person.income.universalCredit.limitedWorkAndRelatedCapability': 'careAssessment.universalCreditAllowances.limitedWorkAndRelatedCapability',
            'person.income.universalCredit.other': 'careAssessment.universalCreditAllowances.other',
            'person.income.universalCredit.earnings': 'careAssessment.universalCreditAllowances.earnings',
            'person.income.universalCredit.capitalTariff': 'careAssessment.universalCreditAllowances.capitalTariff',
            'person.income.universalCredit.debts': 'careAssessment.universalCreditAllowances.debts',

            'person.expenses.councilTax': 'careAssessment.councilTax',

            'person.expenses.compulsoryPayments': 'careAssessment.compulsoryPayments.amount',
            'person.expenses.compulsoryPaymentsPeriod': 'careAssessment.compulsoryPayments.frequency',

            'person.expenses.rent': 'careAssessment.rent.amount',
            'person.expenses.rentPeriod': 'careAssessment.rent.frequency',

            'person.expenses.mortgage': 'careAssessment.mortgage.amount',
            'person.expenses.mortgagePeriod': 'careAssessment.mortgage.frequency',

            'person.expenses.waterRates': 'careAssessment.waterRates.amount',
            'person.expenses.waterRatesPeriod': 'careAssessment.waterRates.frequency',

            'person.expenses.homeContentsInsurance': 'careAssessment.homeContentsInsurance.amount',
            'person.expenses.homeContentsInsurancePeriod': 'careAssessment.homeContentsInsurance.frequency',

            'person.expenses.groundRent': 'careAssessment.groundRent.amount',
            'person.expenses.groundRentPeriod': 'careAssessment.groundRent.frequency',

            'partner.income.retirementPension': 'careAssessment.partner.retirementPension.amount',
            'partner.income.retirementPensionPeriod': 'careAssessment.partner.retirementPension.frequency',

            'partner.income.incapacityBenefit': 'careAssessment.partner.incapacityBenefit.amount',
            'partner.income.incapacityBenefitPeriod': 'careAssessment.partner.incapacityBenefit.frequency',

            'partner.income.warPension': 'careAssessment.partner.warPension.amount',
            'partner.income.warPensionPeriod': 'careAssessment.partner.warPension.frequency',

            'partner.income.warSpecialPayment': 'careAssessment.partner.warSpecialPayment.amount',
            'partner.income.warSpecialPaymentPeriod': 'careAssessment.partner.warSpecialPayment.frequency',

            'partner.income.childBenefit': 'careAssessment.partner.childBenefit.amount',
            'partner.income.childBenefitPeriod': 'careAssessment.partner.childBenefit.frequency',

            'partner.income.carersAllowance': 'careAssessment.partner.carersAllowance.amount',
            'partner.income.carersAllowancePeriod': 'careAssessment.partner.carersAllowance.frequency',

            'partner.income.attendanceAllowance': 'careAssessment.partner.attendanceAllowance',
            'partner.income.mobilityAllowance': 'careAssessment.partner.mobilityAllowance',

            'partner.intro.dob': 'careAssessment.partner.dateOfBirth'
          })
          .factToFieldConverters({
            'partner.intro.dob': function (facts) {
              var dateOfBirth = objectUtils.getPropertyPath(facts, 'careAssessment.partner.dateOfBirth');

              if (dateOfBirth) {
                return this.ISOStringToDDMMYYYY(dateOfBirth);
              }
            },

            'person.intro.dob': function (facts) {
              return this.ISOStringToDDMMYYYY(facts.dateOfBirth);
            },

            // We don't map the formatted (string) address fact to the address form fields because there's no reliable
            // way to convert a comma-delimited address string into an address object with separate properties for
            // line1, line2, postcode, etc.
            //
            // We also don't want to map the address (object) fact to the address form fields, because the UPRN is not
            // included in the former.
            'person.details.address': function (facts) {
              return null;
            }
          })
          .fieldToFactConverters({
            'careAssessment.partner.dateOfBirth': function (model) {
              var dateOfBirth = objectUtils.getPropertyPath(model, 'partner.intro.dob');
              if (dateOfBirth) {
                return this.DDMMYYYYToISOString(dateOfBirth);
              }
            },
            dateOfBirth: function (model) {
              var careAssessmentDob = model.person.intro.dob;
              return this.DDMMYYYYToISOString(careAssessmentDob);
            },
            'address.formatted': function (model) {
              var addressParts = objectUtils.getPropertyPath(model, 'person.details.address');
              return addressFormatterService.formatAsString(
                [addressParts.line1, addressParts.line2, addressParts.line3, addressParts.postcode]);
            }
          });
      };
    }]);
